import type { PairAddress } from './PairAddress'
import type { Equivalence } from '@blade/std-lib'
import type { Network } from '@root/entities/network/model'

export interface Ref {
  address: PairAddress
  network: Network.Network
}

export const eq: Equivalence.Equivalence<Ref> = (self, other) =>
  self.address === other.address && self.network === other.network

export const toString = (value: Ref) => `${value.network}:${value.address}`
